import React, { useState, FormEvent, useEffect, WheelEventHandler } from 'react';
import { useParams } from 'react-router-dom';

import {Suggest2, Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, DialogBody, Callout, Checkbox, Tooltip } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation ,Icon} from "@blueprintjs/core";
//import { DateInput3 } from "@blueprintjs/datetime2";
import { IconNames } from "@blueprintjs/icons";
import { AxiosInstance } from 'axios';
import * as utils from "./utils";
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next';
import svgWait2 from './svg/wait2.gif'
import { Account, CurrencyInfo,StkCodeInfo, FiniInfo,sbConfig} from './Types'
import { SystemHeader,ClientPicker,IPOStockPicker} from './CommonUI';  

import i18next from 'i18next';
import { access } from 'fs';

import svgcaretdown from './svg/caret-down.svg'

interface PageInfo {
    n: number
}

interface PageInfo2 {
    pageno: number,
    pageShow: boolean,
    pageStartno: number,
    pageEndno: number,
    pageLast: boolean,
}


var GsbFlag: any;

var UserID: string;
var PgmCode = "I0002" ;
var isReqAuth2:boolean = false ;
/*
interface IPOEntryViewProps {
    gsb: AxiosInstance,
    Fini: FiniInfo,
    Fini0: FiniInfo,
    CurrencyList?: CurrencyInfo[],
    GsbConfig: sbConfig,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
    PgmMode: any,    
}

*/
interface IPOEntryViewProps {
    gsb: AxiosInstance,
    Fini: FiniInfo,
    Fini0: FiniInfo, 
    CurrencyList?: CurrencyInfo[],
    GsbConfig: sbConfig,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onReplicate?: () => void,  
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
    PgmMode:any,    
}




function IPOEntryView({ gsb, Fini = {} as FiniInfo,Fini0 = {} as FiniInfo, CurrencyList =[] as CurrencyInfo[],  GsbConfig = {} as sbConfig, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { }, ViewMode, logKey2 ,PgmMode}: IPOEntryViewProps) {

const { t, i18n } = useTranslation();   
    
    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)
    const [isCanDelete, setisCanDelete] = useState(true)
    const [isDeletePress2, setisDeletePress2] = useState(false)

 

    const [isOpenDialog, setisOpenDialog] = useState(false)
    const [isOPenAlert, setisOPenAlert] = useState(false)
    const [cAction, setcAction] = useState("")
    const [AuthUser, setAuthUser] = useState("")
    const [password, setPassword] = useState("")

    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")
    const [AcName1Value, setAcName1Value] = useState("")
    const [AcName2Value, setAcName2Value] = useState("")


    const [AcStatusValue, setAcStatusValue] = useState("")

    //Listed cannnot ammmed
    const [FiniListStatusValue,setFiniListStatisValue] = useState(false)

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 

    const [PrevDayValue, setPrevDayValue] = useState(0)
    const [LatestBalValue, setLatestBalValue] = useState(0)
    const [UnClrChqValue, setUnClrChqValue] = useState(0)
    const [d_RebateRate,setd_RebateRate ] =useState("") //useState ((utils.ParseFloat(Fini.d_RebateRate,4)).toString())
    const [showSIMore, setshowSIMore] = useState(true) 
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    
    useEffect(() => {
        (async () => {
            try {
                // get AC Info
               
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Clmast", cAction: "GetACInfo", cAcCode: Fini.d_acCode })
                
                if ( Fini.d_acCode.trim().length > 0 && res.data.count > 0 )
                {
                    //console.log("1223 res.data.data[0].d_acCode",res.data.data[0].d_acCode)
                    //setAcName1Value(res.data.data[0].d_acName1)
                    //setAcName2Value(res.data.data[0].d_acName2)
                    setAcStatusValue(res.data.data[0].d_status)
                    //setAeCodeValue (res.data.data[0].d_aeCode)
                } else { 
                    //setAcName1Value("")
                    //setAcName2Value("")
                    setAcStatusValue("")
                    //setAeCodeValue("")
                }
            
            } catch (error) {
                showErrorBox(error)
            }
        })()
    }, [gsb, Fini])

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("IPOEntryView UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, Fini])


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }




    if (! ("d_acCode" in Fini)) return null
/*

    const AcNOToolTip = 
    <div>
        <div>Account No. </div>
        <div>Cash A/C : ACCOUNT=Axxxx, CUSTODY=Pxxxx </div> 
        <div>Margin A/C : MARGIN=Mxxxx </div> 
        <div>RUNNER=Cxxxx, INTERNAL=Ixxxx </div> 
   </div>

*/

    return (
        <div>
            {/* define add,change,delete button */}
            <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                {/* <Button className="Col-2-1" icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" icon="delete" onClick={() => onDelete()} >Delete</Button> */}
          
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true)} >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                {/* <Button className="Col-7-2" icon="document" onClick={() => { window.open(`/#/BookClosedQty?Stkno=${Fini.d_StkNo}?IPONo=${Fini.d_IPONo}`, '_blank') } } >Book Closed Qty</Button> */}
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Seq No.">
                    <InputGroup readOnly value={utils.formatNumber2(Fini.d_Seq)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini.d_Seq.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(Fini0.d_Seq)} </div> }
                </FormGroup>

                <FormGroup className="Col-2-1" label="PrePaid Aoumt posted" labelFor="inputPrePaidAmtoSB" >
                    {/*<InputGroup className="inputPrePaidAmtoSB" disabled={false} id="inputPrePaidAmtoSB" name="d_OAPOST" autoFocus={isNew}  inputRef={register} /> */}
                  
                    {Fini.d_OAPOST}                 
                  
                   
                </FormGroup> 
          
                <FormGroup className="Col-3-1" label="Qty posted" labelFor="inputQtyToSB">
                    {/*<InputGroup className="inputQtyToSB" disabled={true} id="inputQtyToSB" name="d_OIPOST" autoFocus={isNew} inputRef={register} />*/}
                    {Fini.d_OIPOST}                                       
                </FormGroup>
              
         
                <FormGroup className="Col-4-1" label="Amount posted" labelFor="inputAmtPostedToSb">
                   {/*<InputGroup className="inputAmtPostedToSb" disabled={false} id="inputAmtPostedToSb" name="d_OIAMTPOST" autoFocus={isNew}  inputRef={register} /> */}
                   {Fini.d_OIAMTPOST}
                </FormGroup> 

 
                <FormGroup className="Col-5-1" label="Input User" labelFor="inputUser">
                    <InputGroup readOnly value={Fini.d_Input_User} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_Input_User.toString() == "") && 
                    <div id="DispText2" > {Fini0.d_Input_User} </div> }
                </FormGroup>               
                <FormGroup className="Col-1-1" label="Cheque No:">
                    <InputGroup readOnly value={Fini.d_OCHQ } />
                </FormGroup> 

            </div>

            <div className="Row">

                <FormGroup className="Col-1-2" label="Stock No" labelFor="inputStkNo">
                    <InputGroup readOnly value={Fini.d_StkNo} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_StkNo.toString() == "") && 
                    <div id="DispText" > {Fini0.d_StkNo} </div> }
                </FormGroup>

                <FormGroup className="Col-3-2" label="Stock Code" labelFor="inputStk">
                    {/*
                    <InputGroup readOnly value={Fini.d_StkCode} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_StkCode.toString() == "") && 
                    <div id="DispText2" > {Fini0.d_StkCode} </div> }*/}
                    <div id="DispText" > {(Fini.d_StkCode)} </div>         
                </FormGroup>   

                <FormGroup className="Col-5-3" label="Stock Name" labelFor="inputStkName">
                {/*<InputGroup readOnly value={Fini.d_StkName} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_StkName.toString() == "") && 
                    <div id="DispText2" > {Fini0.d_StkName} </div> }*/}

                    <div id="DispText" > {(Fini.d_StkName)} </div>
                </FormGroup>   
            </div>

            <div className="Row">
                    <FormGroup className="Col-1-2" label="Lot size" labelFor="inputLotSize" >
                        <div id="DispText" > {Fini.d_LotSize}</div>                              
                    </FormGroup >           
            </div>
            <div className="Row">     
      
                <FormGroup className="Col-1-2" label="Appy Date.">
                    <InputGroup readOnly value={utils.dispDate(Fini.d_ApplyDate,GsbFlag.dateFormat)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_ApplyDate.toString() == "") && 
                    <div id="DispText2" > {utils.dispDate(Fini.d_ApplyDate, GsbFlag.dateFormat)} </div> }
                </FormGroup>
                <FormGroup className="Col-3-2" label="List Date.">
                    <InputGroup readOnly value={utils.dispDate(Fini.d_ListingDate, GsbFlag.dateFormat)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_ListingDate.toString() == "") && 
                    <div id="DispText2" > {utils.dispDate(Fini0.d_ListingDate, GsbFlag.dateFormat)} </div> }
                </FormGroup>
         
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Apply Price.">

                   <div id="DispText" > {(utils.ParseFloat(Fini.d_ApplyPrice,4)).toString()}  </div>        

                </FormGroup >
                <FormGroup className="Col-3-2" label="Comm Rate.">
                    <div id="DispText" >{(utils.ParseFloat(Fini.d_CommRate,4)).toString()}</div>        
           
                </FormGroup > 
           
            
            </div>
            <div className="Spacing-V-16" />
 
            <div className="Row">
                <FormGroup className="Col-1-2" label="Transaction Levy (%)">                  
                    <div id="DispText" > {Fini.d_LevyRate}</div>                     
                </FormGroup >         
                <FormGroup className="Col-3-2" label="AFRC levy Rate(%)">                   
                    <div id="DispText" > {Fini.d_AFRCLevyRate}</div>      
                </FormGroup >
                <FormGroup className="Col-5-2" label="Trading Fee">
                    <div id="DispText" > {Fini.d_TradingFeeRate}</div>   
                </FormGroup >
                <FormGroup className="Col-7-2" label="Nominee handling Fee">
                    <div id="DispText" > {(utils.ParseFloat(Fini.d_HandlingFee,2)).toString()} </div>                      
                </FormGroup >
            </div>

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Account No.">
                    <InputGroup readOnly value={(Fini.d_acCode)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_acCode.toString() == "") && 
                    <div id="DispText" > {(Fini0.d_acCode)} </div> }
                </FormGroup>
                {/*Client Name*/}
                <FormGroup className="Col-2-3" label="Client Name.">
                    <div id="DispText" > {(Fini.d_acName1)} </div>
                    <div id="DispText" > {(Fini.d_acName2)} </div>       
                </FormGroup>
                <FormGroup className="Col-5-1" label="Runner.">
                    <div id="DispText" > {(Fini.d_aeCode)} </div>            
                </FormGroup>
                <FormGroup className="Col-7-2" label="Status." labelFor="inputStatus">                     
                    <div id="DispText">{(AcStatusValue)}</div>                                     
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Receive Pre-Pay Date">
                    <InputGroup readOnly value= {utils.dispDate(Fini.d_OPPDATE, GsbFlag.dateFormat)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (utils.dispDate(Fini0.d_OPPDATE, GsbFlag.dateFormat).toString() == "") && 
                    <div id="DispText2" >  {utils.dispDate(Fini0.d_OPPDATE, GsbFlag.dateFormat)} </div> }
                </FormGroup >
                <FormGroup className="Col-1-2" label="Apply Qty.">
                    <InputGroup readOnly value={utils.formatNumber(Fini.d_ApplyQty)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_ApplyQty.toString() == "") && 
                    <div id="DispText2" > {(Fini0.d_ApplyQty)} </div> }
                </FormGroup >


                <FormGroup className="Col-3-2" label="Total Amount">
                    <InputGroup readOnly value={utils.formatNumber2(Fini.d_ApplyAmount)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_ApplyAmount.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(Fini0.d_ApplyAmount)} </div> }
                </FormGroup >


                <FormGroup className="Col-5-2" label="currency">
                    <InputGroup readOnly value={(Fini.d_Currency)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_Currency.toString() == "") && 
                    <div id="DispText2" > {(Fini0.d_Currency)} </div> }
                </FormGroup >
                {/*
                <FormGroup className="Col-3-2" label="EIPO">
                    <InputGroup readOnly value={(Fini.d_OGENEPIO)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_OGENEPIO.toString() == "") && 
                    <div id="DispText2" > {(Fini0.d_OGENEPIO)} </div> }
                </FormGroup>
                */}
            </div>

            {/*
            <div className="Row">
                 <FormGroup className="Col-1-2" label="List Price.">
                    <InputGroup readOnly value={utils.formatNumber(Fini.d_OIPRICE)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_OIPRICE.toString() == "") && 
                    <div id="DispText2" > {(Fini0.d_OIPRICE)} </div> }
                </FormGroup >
                <FormGroup className="Col-3-2" label="List Qty.">
                    <InputGroup readOnly value={utils.formatNumber(Fini.d_OISQTY)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_OISQTY.toString() == "") && 
                    <div id="DispText2" > {(Fini0.d_OISQTY)} </div> }
                </FormGroup >
            </div>
            */}


            <div className="Row">              

            <FormGroup className="Col-1-2" label="Consideration">
                    <InputGroup readOnly value={ utils.numToString3 (Fini.d_Turnover)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_Turnover.toString() == "") && 
                    <div id="DispText2" > {utils.numToString3(Fini0.d_Turnover)} </div> }
                </FormGroup >

                <FormGroup className="Col-3-2" label="Commission Amount.">
                    <InputGroup readOnly value={utils.formatNumber2(Fini.d_EstCommAmt)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_EstCommAmt.toString() == "") && 
                    <div id="DispText2" > {(Fini0.d_EstCommAmt)} </div> }
                </FormGroup >
            </div>


            <div className="Row">
                 <FormGroup className="Col-1-2" label="Transacation Levy Amount">
                    <InputGroup readOnly value={utils.numToString2(Fini.d_EstTransLevy)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_EstTransLevy.toString() == "") && 
                    <div id="DispText2" > {(Fini0.d_EstTransLevy)} </div> }
                </FormGroup >
                <FormGroup className="Col-3-2" label="AFRC Levy Amount">
                    <InputGroup readOnly value={utils.numToString2(Fini.d_OFLEVY)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_OFLEVY.toString() == "") && 
                    <div id="DispText2" > {(Fini0.d_OFLEVY)} </div> }
                </FormGroup >

                <FormGroup className="Col-5-2" label="Trading Fee Amount">
                    <InputGroup readOnly value={utils.numToString2(Fini.d_EstTradingFee)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_EstTradingFee.toString() == "") && 
                    <div id="DispText2" > {(Fini0.d_EstTradingFee)} </div> }
                </FormGroup >
            </div>
   
            <div className="Spacing-V-16" />

 
            <div className="Row">
               <FormGroup className="Col-1-2" label="Pre-Paid Rate">
                    <InputGroup readOnly value={utils.numToString(Fini.d_PrePaidRate)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_PrePaidRate.toString() == "") && 
                    <div id="DispText2" > {(Fini0.d_PrePaidRate)} </div> }
                </FormGroup >
                <FormGroup className="Col-3-2" label="Pre-Paid Amount">
                    <InputGroup readOnly value={(utils.numToString2((Fini.d_PrePaidAmt)))} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_PrePaidAmt.toString() == "") && 
                    <div id="DispText2" > {( (utils.StringToNum2(Fini.d_PrePaidAmt)))} </div> }
                </FormGroup >

                <FormGroup className="Col-5-2" label="Loan Amount">
                    <InputGroup readOnly value={utils.formatNumber3(utils.StringToNum(Fini.d_LoanAmt),2)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_LoanAmt.toString() == "") && 
                    <div id="DispText2" > {(Fini0.d_LoanAmt)} </div> }
                </FormGroup >

                <FormGroup className="Col-1-2" label="Interest Rate(%)">
                    <InputGroup readOnly value={utils.numToString(Fini.d_IntRate)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_IntRate.toString() == "") && 
                    <div id="DispText2" > {(Fini0.d_IntRate)} </div> }
                </FormGroup >
                <FormGroup className="Col-3-2" label="Loan Day">
                    <InputGroup readOnly value={utils.numToString(Fini.d_LoanDay)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_LoanDay.toString() == "") && 
                    <div id="DispText2" > {(Fini0.d_LoanDay)} </div> }
                </FormGroup >

                <FormGroup className="Col-1-2" label="Rebate Rate(%)">
                    <InputGroup readOnly   value={ utils.numToString(utils.StringToNum(Fini.d_RebateRate))} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (utils.formatNumber3(utils.StringToNum(Fini0.d_RebateRate)) == "") && 
                    <div id="DispText2" > {utils.formatNumber3(utils.StringToNum(Fini0.d_RebateRate))} </div> }
                </FormGroup >
                <FormGroup className="Col-3-2" label="Rebate Amount">
                    <InputGroup readOnly value={utils.formatNumber3(utils.StringToNum(Fini0.d_EstRebateAmt),2)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_EstRebateAmt.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber3(utils.StringToNum(Fini0.d_EstRebateAmt),2)} </div> }
                </FormGroup >
            </div>
      
        </div>
    )
}

interface IPOEntryEditProps {
    gsb: AxiosInstance,
    Fini?: FiniInfo,
    CurrencyList?: CurrencyInfo[],
    GsbConfig?: sbConfig,
    isNew?: boolean,
    onSave?: (stk: FiniInfo) => void,
    onCancel?: () => void,
    PgmMode: any,    
}


function IPOEntryEdit({ gsb, Fini = {} as FiniInfo, CurrencyList=[] as CurrencyInfo[],  GsbConfig = {} as sbConfig, isNew = false, onSave = () => { }, onCancel = () => { } ,PgmMode}: IPOEntryEditProps) {

    const [isReqAuth, setisReqAuth] = useState(false)
    
    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<FiniInfo>()

    const imgCaretdown = <img className="downIcon" src={svgcaretdown} alt="caretdown" />
    const { t, i18n } = useTranslation();    
   
    const [StkCodeList, setStkCodeList] = useState([] as StkCodeInfo[])
    const [CCASSStockValue, setCCASSStockValue] = useState(false)
//key2
    const [InputDateValue,setInputDateValue]= useState( (Fini.d_InputDate))
  
  
    const [AcCodeValue, setAcCodeValue] = useState(Fini.d_acCode)
    const [setClCodeValue, setSetClCodeValue] = useState(() => setAcCodeValue)
    const [isClPickerOpen, setIsClPickerOpen] = useState(false)   

    //StkNo
    const [IPOStkNoValue, setIPOSTKNoValue] = useState(Fini.d_StkNo)
    const [setIPOStkNoValue, setsetIPOSTKNoValue] = useState(() => setIPOSTKNoValue)

    //StkName
    const [IPOStkNameValue, setIPOStkNameValue] = useState(Fini.d_StkName)
    const [setIPOMStkNameValue, setsetIPOStkNameValue] = useState(() => setIPOStkNameValue)

    //StkName Big5
    const [IPOStkBig5NameValue, setIPOStkBig5NameValue] = useState("")
    const [setIPOMStkBig5NameValue, setsetIPOStkBig5NameValue] = useState(() => setIPOStkBig5NameValue)

    //Comm Rate
    const [IPOCommRateValue,setIPOComRateValue] = useState(utils.numToString2(Fini.d_CommRate))
    const [setIPOCommRate,setsetIPOCommRate ] = useState (()=> setIPOComRateValue)

    //StkCode
    const [IPOStockValue, setIPOStockValue] = useState(Fini.d_StkCode)
    const [setIPOStkValue, setsetIPOStkValue] = useState(() => setIPOStockValue)
   
    //Price
    const [IPOApplyPriceValue, setIPOApplyPriceValue] = useState(utils.numToString2(Fini.d_ApplyPrice))
    const [setIPOApplyPrice, setsetIPOApplyPrice] = useState(() => setIPOApplyPriceValue)
    
    //lot isze
    const [IPOLotSize, setIPOLotSize] = useState(utils.numToString(Fini.d_LotSize))
    const [setIPOLotSizeValue, setsetIPOLotSizeValue] = useState(() =>setIPOLotSize)


    //Apply Date
    const [IPOApplyDateValue, setIPOApplyDateValue] = useState(Fini.d_ApplyDate)
    const [setIPOApplyDAteValue, setsetIPOApplyDAteValue] =  useState(() => setIPOApplyDateValue)
  
    //Listing date
    const [IPOListingDateValue, setIPOListingDateValue] = useState(Fini.d_ListingDate)
    const [setIPOListingDAteValue, setsetIPOListingDAteValue] =  useState(() => setIPOListingDateValue)
  
    // Loan Intereset Rate 
    const [IPOIntRateVaue, setIPOIntRateValue] = useState(utils.numToString2(Fini.d_IntRate))
    const [setIPOIntRate, setsetIPOIntRate] =  useState(() => setIPOIntRateValue)
    
    //Rebate rate
    const [IPORebateRateVaue, setIPORebateRateValue] = useState(utils.numToString2(Fini.d_RebateRate))
    const [setIPORebateRate, setsetIPORebateRate] =  useState(() => setIPORebateRateValue)  

    //Loan Day
    const [IPOLoanDay, setIPOLoanDay] = useState(utils.numToString2(Fini.d_LoanDay))
    const [setIPOLoanDayValue, setsetIPOLoanDayValue] =  useState(() => setIPOLoanDay)
  
    //Apply Qty
    const [IPOApplyQtyValue,setIPOApplyQtyValue] = useState(utils.numToString2(Fini.d_ApplyQty))
    //Paid Prate 
    const[PrePaidRateValue,setPrePaidRateValue] = useState(utils.numToString2(Fini.d_PrePaidRate))
    const[o_PrePaidRateValue,seto_PrePaidRateValue] = useState(utils.numToString2(Fini.d_PrePaidRate))

   //Paid Prate Amounnamt
   const[PrePaidAmtValue,setPrePaidAmtValue] = useState(utils.numToString2 (Fini.d_PrePaidAmt))

  // const[PrePaidAmtValue2,setPrePaidAmtValue2] = useState(utils.formatNumber2 (Fini.d_PrePaidAmt))

    
 

    const [IPOHandlingFee, setIPOHandlingFee] = useState(utils.numToString2(Fini.d_HandlingFee)) 
    const [setIPOHandlingFeeValue, setsetIPOHandlingFeeValue] =  useState(() => setIPOHandlingFee)
  

    const [isIPOPickerOpen, setIsIPOPickerOpen] = useState(false)   

    //const [AcCodeList, setAcCodeList] = useState([] as AcCodeInfo[])
    const [searchStk,setsearchStk] = useState("")    
    const [cStk,setcStk] =useState(Fini.d_StkCode)

    const [CurrencyValue,setCurrencyValue] = useState("")
    const [StkValue ,setStkValue] = useState ("")
    const [StkNoValue,setStkNoValue] = useState("")     
    const [StkNameValue,setStkNameValue] = useState("")

    const [AcName1Value, setAcName1Value] = useState(Fini.d_acName1)    
    const [AcName2Value, setAcName2Value] = useState(Fini.d_acName2)
  
    const [AcStatusValue, setAcStatusValue] = useState("")

    //const [CommCodeValue,setCommCodeValue] = useState(Fini.d_cp)
   
    const [AeCodeValue, setAeCodeValue] = useState(Fini.d_aeCode)

   //const [AcStatusValue, setAcStatusValue] = useState(ac.d_status)
    //const [AeCodeValue, setAeCodeValue] = useState(ac.d_aeCode)
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [showChannel, setshowChannel] = useState(false)
    const [showMULTI_PRCE, setshowMULTI_PRCE] = useState(false)

    
  //  const [d_CommAmt, setd_CommAmt] = useState(Fini.d_EstCommAmt)       // Estimate Commission Amount

    const [d_OREBATE, setd_OREBATE] = useState(utils.numToString2(Fini.d_EstCommAmt))      // Estimate Rebate Amount    // Estimate Rebate Amount
    //const [d_HandlingFee, setd_HandlingFee] = useState(Fini.d_HandlingFee)    

    const [d_LoanAmt, setd_OLOANAMT] = useState(utils.numToString2(Fini.d_LoanAmt))    
    const [IPOApplyAmtValue, setIPOApplyAmtValue] = useState(utils.numToString2(Fini.d_ApplyAmount))        // Apply Amount 
  
 
   // const[d_OAPOST,setd_OAPOST] = useState(Fini.d_OAPOST) // Pre-Paid Amount    
    const[d_OCMAMT,setd_OCMAMT] = useState(utils.numToString(Fini.d_OCMAMT))       // Final Commission Amount
    const[d_ORFAMT,setd_ORFAMT] = useState(utils.numToString(Fini.d_ORFAMT))       // Refund Amount
    const[d_OINAMT,setd_OINAMT] = useState(utils.numToString(Fini.d_OINAMT))       // Interest Amount

 
    //BlankAc.d_CommRate =   "1.0000"
    const[d_CommRate,setd_CommRate] = useState(utils.numToString(Fini.d_CommRate))

   
    const [d_Turnover,setd_Turnover] = useState(utils.numToString(Fini.d_Turnover))
    const [d_Turnover2,setd_Turnover2] = useState((""))
    const[d_ApplyType,setd_ApplyType] = useState("Y")      	//    Francis Add Default Type = "Yellow Form" For EIPO -> 100% pre-paid   
 
    // Estimate Commission Amount
    const [EstCommAmtValue ,setEstCommAmtValue ] = useState(utils.numToString2(Fini.d_EstCommAmt))

    // Estimate Rebate Amount
    const [EstRebateAmtValue ,setEstRebateAmtValue ] = useState(utils.numToString(Fini.d_EstRebateAmt))
 
    // Estimate Trading Fee
    const [EstTradingFeeValue ,setEstTradingFeeValue ] = useState(utils.numToString(Fini.d_EstTradingFee))
 
    
    //Trading Fee (%)
    const [SLevy_RateValue, setSLevy_RateValue] = useState(utils.numToString(Fini.d_TradingFeeRate))
    //levy rate
    const [Levy_RateValue, setLevy_RateValue] =  useState(utils.numToString(Fini.d_LevyRate))
    //AFRCLevy
    const [FLevy_RateValue, setFLevy_RateValue] = useState(utils.numToString(Fini.d_AFRCLevyRate))

    const [TranscationLevyAmt, setTranscationLevyAmt] = useState(utils.numToString(Fini.d_EstTransLevy))
    const [AFrcLevtAmt, setAFrcLevtAmt] = useState(utils.numToString(Fini.d_OFLEVY))
    const [TradingFeeAmt, setTradingFeeAmt] = useState(utils.numToString(Fini.d_EstTradingFee))
  


    const [d_OIPOST ,setd_OIPOST ] = useState((Fini.d_OIPOST))
    const [d_OIAMTPOST ,setd_OIAMTPOST ] = useState((Fini.d_OIAMTPOST))
    const[d_OAPOST,setd_OAPOST] = useState(Fini.d_OAPOST) 
    const [d_OSKIPCHQ ,sed_OSKIPCHQ] = useState((Fini.d_OSKIPCHQ))


    let o_Skip_Recal = Fini.d_Skip_Recal 

    useEffect(() => {
        (async () => {
            try {      
                if (isNew)
                {
                    //setSLevy_RateValue(GsbConfig.x_SLEVY_RATE) //Trading Fee (%)
                    //setLevy_RateValue(GsbConfig.x_LEVY_RATE)                         //Transaction Levy (%)
                    //setFLevy_RateValue(GsbConfig.x_FLEVY_RATE)    
                    setd_OIPOST("N")
                    setd_OIAMTPOST("N")
                    setd_OAPOST("N")
                    sed_OSKIPCHQ("Y")
                    setPrePaidRateValue("100")
                }
                else
                {
                    setd_OIPOST(Fini.d_OAPOST)
                    setd_OIAMTPOST(Fini.d_OIAMTPOST)
                    setd_OAPOST(Fini.d_OAPOST)
                    sed_OSKIPCHQ(Fini.d_OSKIPCHQ)

                    setIPOHandlingFee(utils.numToString(Fini.d_HandlingFee))
                }
                
            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [ ])

    
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                // setuserKey(GsbFlag.user_key)
                // setGSBx_USER(GsbFlag.GSBx_USER) ;
                // setdateFormat(GsbFlag.dateFormat)
            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, GsbConfig ])
 
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
 
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }

                setshowChannel( GsbFlag.MULTI_CHNL ) ;
                setshowMULTI_PRCE( GsbFlag.MULTI_PRCE ) ;

       

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])  

    let o_acCode = Fini.d_acCode
    useEffect(() => {
        (async () => {
            try {
                // get AC Info
                setAcCodeValue(AcCodeValue.toUpperCase())
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Clmast", cAction: "GetACInfo", cAcCode: AcCodeValue })
                
                if ( AcCodeValue.trim().length > 0 && res.data.count > 0 )
                {

                    console.log("1223 res.data.data[0].d_aeCode",res.data.data[0].d_aeCode)
                    setAcName1Value(res.data.data[0].d_acName1)
                    setAcName2Value(res.data.data[0].d_acName2)
                    setAcStatusValue(res.data.data[0].d_status)
                    setAeCodeValue (res.data.data[0].d_aeCode)
                } else { 
                    setAcName1Value("")
                    setAcName2Value("")
                    setAcStatusValue("")
                    setAeCodeValue("")
                }
            
            } catch (error) {
                showErrorBox(error)
            }
        })()

    }, [gsb, AcCodeValue,AeCodeValue])


    useEffect(() => {
        (async () => {
            try {
                // get AC Info
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "IPOMast", cAction: "GetIPOInfo", s_StkNo: IPOStkNoValue})
                if  (res.data.count > 0 )
                {
                    console.log("1223 res.data.data[0].d_StkNo",res.data.data[0])
                    if ( IPOStkNoValue.trim().length > 0   )
                    {                       
                            setIPOApplyDateValue(utils.dispDate((res.data.data[0].d_ApplyDate),GsbFlag.format))
                            setIPOListingDateValue(utils.dispDate((res.data.data[0].d_ListingDate),GsbFlag.format))
                           
                            setIPOLoanDayValue((res.data.data[0].d_LoanDay))                         
                            setIPORebateRateValue( res.data.data[0].d_RebateRate)
                            setIPOComRateValue(res.data.data[0].d_CommRate)
                            setIPOIntRateValue((res.data.data[0].d_IntRate))
                            setIPOHandlingFee(res.data.data[0].d_HandlingFee)
                            setIPOStockValue(res.data.data[0].d_StkCode)
                            setIPOStkNameValue(res.data.data[0].d_StkName)
                            setIPOLotSize(res.data.data[0].d_LotSize)    
                            
                            setIPOApplyPrice(res.data.data[0].d_ApplyPrice)

                            setSLevy_RateValue(res.data.data[0].d_TradingFeeRate)  //Transaction Levy (%)
                            setLevy_RateValue(res.data.data[0].d_LevyRate)
                            setFLevy_RateValue(res.data.data[0].d_AfrcLevyRate)
                       
                    } else { 
 
                    
                    }
                }  
            
            } catch (error) {
                showErrorBox(error)
            }
        })()

    }, [gsb, IPOStkNoValue])
 
 
    useEffect(() => {
        //console.log("re-calc PrePaidRate",o_PrePaidRateValue, PrePaidRateValue)

        //M_AAMT := M_TRADE + M_COMM + M_LEVY + M_FLEVY + M_SLEVY
        var temp_App_Amt = utils.StringToNum2(d_Turnover) + utils.StringToNum2(EstCommAmtValue) + utils.StringToNum2(TranscationLevyAmt) + utils.StringToNum2(AFrcLevtAmt) + utils.StringToNum2(TradingFeeAmt)
        setIPOApplyAmtValue(utils.numToString3(temp_App_Amt))

        var tmp_PrePaid_Amt = utils.StringToNum2(PrePaidAmtValue)
        if (o_PrePaidRateValue.trim() !== PrePaidRateValue.trim()) {
            var tmp_PrePaidRate = utils.StringToNum2(PrePaidRateValue)
            if ( tmp_PrePaidRate > 100 ) {
                tmp_PrePaidRate = 100
            }
            if ( tmp_PrePaidRate < 0 ) {
                tmp_PrePaidRate = 0
            }
            var tmp_PrePaid_Amt = temp_App_Amt * tmp_PrePaidRate/ 100
            tmp_PrePaid_Amt = tmp_PrePaid_Amt + utils.StringToNum2(IPOHandlingFee)
            setPrePaidAmtValue(utils.numToString3(tmp_PrePaid_Amt))
            setPrePaidRateValue(utils.numToString2(tmp_PrePaidRate))
            seto_PrePaidRateValue(PrePaidRateValue)
        }

        if ( tmp_PrePaid_Amt > temp_App_Amt ) {
            tmp_PrePaid_Amt = temp_App_Amt + utils.StringToNum2(IPOHandlingFee)
            setPrePaidAmtValue(utils.numToString3(tmp_PrePaid_Amt))
        }
        if ( tmp_PrePaid_Amt < 0 ) {
            tmp_PrePaid_Amt = 0
            setPrePaidAmtValue(utils.numToString3(tmp_PrePaid_Amt))
        }


        //M_LOANAMT := M_TRADE+M_COMM+M_LEVY+M_SLEVY+M_FLEVY+M_HANDLE - M_PREPAID	 
        var temp_Loan_Amt = temp_App_Amt + utils.StringToNum2(IPOHandlingFee) - tmp_PrePaid_Amt
        if ( temp_Loan_Amt < 0 ) {
            temp_Loan_Amt= 0
        }
        setd_OLOANAMT(utils.numToString3(temp_Loan_Amt))
    }, [gsb, d_Turnover, EstCommAmtValue, TranscationLevyAmt, AFrcLevtAmt, TradingFeeAmt, IPOHandlingFee, PrePaidRateValue, PrePaidAmtValue])


    useEffect(() => {
        // Call reset to get the values of record BrokerTranInfo 
        if ("d_Seq" in Fini) {
            reset(Fini)
        }
    }, [Fini, reset])


   

       useEffect(() => {
            // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
            register({ name: "d_Currency" })   
        
        
        }, [register])


    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])  
    
    if (! isNew && ! ("d_Seq" in Fini)) return null

    const onSubmit = (data: FiniInfo) => {


              data.d_InputDate = InputDateValue
              data.d_acCode = AcCodeValue;
               if ( typeof(data.d_acCode) === "undefined" ) {
                   data.d_acCode = ""
               };
      // BlankAc.d_CommRate =   "1.0000"
               data.d_acCode = data.d_acCode.toUpperCase();
               data.d_acName1 = AcName1Value
               data.d_acName2 = AcName2Value
               data.d_aeCode = AeCodeValue
               data.d_status = AcStatusValue
               
               data.d_Currency = CurrencyValue
               if ( typeof(data.d_Currency) === "undefined" ) {
                   data.d_Currency = ""
               }
               data.d_Currency = data.d_Currency.toUpperCase();       
               data.d_Seq = data.d_Seq ;  
               data.d_LevyRate = utils.StringToNum(Levy_RateValue);
               data.d_AFRCLevyRate = utils.StringToNum(FLevy_RateValue);               
               data.d_TradingFeeRate = utils.StringToNum(SLevy_RateValue);
               data.d_CommRate = utils.StringToNum(IPOCommRateValue);
                if ( typeof(data.d_OCHQ) === "undefined" ) {
                   data.d_OCHQ = "N"
                }
                data.d_OCHQ = data.d_OCHQ ;
                data.d_OAPOST = d_OAPOST;    
                data.d_OIPOST = d_OIPOST; 
                data.d_OIAMTPOST = d_OIAMTPOST; 
 
                if(!isNew)
                {
                    data.d_OIPRICE = utils.StringToNum("0")
                    data.d_OISQTY = utils.StringToNum("0")
                    
                }         

                data.d_OSKIPCHQ = d_OSKIPCHQ;
                data.d_StkNo = IPOStkNoValue;              
                data.d_ApplyPrice =  utils.StringToNum2(IPOApplyPriceValue);
                data.d_ApplyQty =  utils.StringToNum2(IPOApplyQtyValue);
                data.d_StkCode =  (IPOStockValue);
                data.d_StkName =   (IPOStkNameValue);
                data.d_LotSize =utils.StringToNum2 (IPOLotSize);
               //data.d_StkName = IPOStkNameValue;                
                data.d_HandlingFee =utils.StringToNum2 (IPOHandlingFee);                

                data.d_LoanDay =utils.StringToNum2 (IPOLoanDay);
                data.d_IntRate = utils.StringToNum2 (IPOIntRateVaue);
                data.d_RebateRate = utils.StringToNum2 (IPORebateRateVaue);

                //custom update value
                data.d_ApplyAmount =utils.StringToNum2(IPOApplyAmtValue);

                // Pre-Paid Ratio (%)
                data.d_PrePaidRate = utils.StringToNum2(PrePaidRateValue)
                // Pre-Paid Amount
                data.d_PrePaidAmt = utils.StringToNum2(PrePaidAmtValue)

                 // Estimate Commission Amount
                 data.d_EstCommAmt= utils.StringToNum2(EstCommAmtValue)
                // Estimate Rebate Amount
                data.d_EstRebateAmt = utils.StringToNum2(EstRebateAmtValue) 
                data.d_EstTransLevy = utils.StringToNum2(TranscationLevyAmt)
 
                data.d_OFLEVY = utils.StringToNum2(AFrcLevtAmt) 
                data.d_EstTradingFee = utils.StringToNum2(TradingFeeAmt) 
                data.d_ApplyType = "Y";

                if ( typeof(data.d_Skip_Recal) === "undefined" ) {
                    data.d_Skip_Recal = o_Skip_Recal
                }
        
                data.d_AuthTran = ""
                if (isReqAuth) {
                   data.d_AuthTran = "Y"
                }
       
               (async () => {
                   try {
                       console.log("call IPOEntryEdit data", data)
                       console.log("call IPOEntryEdit isNew", isNew)
                       const res = await gsb.post('/Master', {sb_data: data, cPgmId: "IPOEntry", cAction: "IPOEntryValidate", isNew: isNew})
                       if (! res.data.ok) {
                           for (let j = 0; j < res.data.data.length; j++) {
                               setError(res.data.data[j][0], {
                                  message: res.data.data[j][1]
                               }); 
                           }
                           return
                       }
                       else
                       
                       onSave(data)
                   } catch (error) {
                     ///  showErrorBox(error)
       
                       utils.showError(error)
                   }
               })()
             
           }
           
           const CurrencyRenderer: ItemRenderer<CurrencyInfo> = (CurrencyList, { handleClick, modifiers, query }) => {
               if (!modifiers.matchesPredicate) {
                   return null;
               }
               const text = `${CurrencyList.d_CcyDesc}`;
               return (
                   <MenuItem
                       active={modifiers.active}
                       disabled={modifiers.disabled}
                       label={CurrencyList.d_Currency}
                       key={CurrencyList.d_Currency}
                       onClick={handleClick}
                       text={highlightText(text, query)}
                   />
               );
           };
       
           const CurrencyPredicate: ItemPredicate<CurrencyInfo> = (query, CurrencyList, _index, exactMatch) => {
               const normalizedText = `${CurrencyList.d_Currency} - ${CurrencyList.d_CcyDesc}`.toLowerCase();
               const normalizedQuery = query.toLowerCase();
       
               if (exactMatch) {
                   return normalizedText === normalizedQuery;
               } else {
                   return normalizedText.indexOf(normalizedQuery) >= 0;
               }
           };
       
           const CurrencyValueRenderer = (CurrencyList: CurrencyInfo) => {
               return CurrencyList.d_Currency
           }
       
       
       
           const StkRenderer: ItemRenderer<StkCodeInfo> = (stk, { handleClick, modifiers, query }) => {
               if (!modifiers.matchesPredicate) {
                   return null;
               }
               //const text = `${ac.acCode} - ${ac.acName1}`;
               const text = `${stk.d_StkCode}`;
               return (
                   <MenuItem
                       active={modifiers.active}
                       disabled={modifiers.disabled}
                       label={stk.d_StkNo}
                       key={stk.d_StkNo}
                       onClick={handleClick}
                       text={highlightText(text, query)}
                   />
               );
           };
       
           const StkPredicate: ItemPredicate<StkCodeInfo> = (query, stk, _index, exactMatch) => {
               const normalizedText = `${stk.d_StkNo} - ${stk.d_StkCode}`.toLowerCase();
               const normalizedQuery = query.toLowerCase();
       
               if (exactMatch) {
                   return normalizedText === normalizedQuery;
               } else {
                   return normalizedText.indexOf(normalizedQuery) >= 0;
               }
           };
       
           const StkValueRenderer = (stk: StkCodeInfo) => {
               return stk.d_StkNo
           }
       
       
           function highlightText(text: string, query: string) {
               let lastIndex = 0;
               const words = query
                   .split(/\s+/)
                   .filter(word => word.length > 0)
                   .map(escapeRegExpChars);
               if (words.length === 0) {
                   return [text];
               }
               const regexp = new RegExp(words.join("|"), "gi");
               const tokens: React.ReactNode[] = [];
               while (true) {
                   const match = regexp.exec(text);
                   if (!match) {
                       break;
                   }
                   const length = match[0].length;
                   const before = text.slice(lastIndex, regexp.lastIndex - length);
                   if (before.length > 0) {
                       tokens.push(before);
                   }
                   lastIndex = regexp.lastIndex;
                   tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
               }
               const rest = text.slice(lastIndex);
               if (rest.length > 0) {
                   tokens.push(rest);
               }
               return tokens;
           }
       
           function escapeRegExpChars(text: string) {
               //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
               return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
           }
       
           const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
               //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)
       
               // ctrl + s
               if (e.ctrlKey && e.keyCode === 83) {
                   e.preventDefault()
                   handleSubmit(onSubmit)()
               }
           }
       
           const showErrorBox = (err: any) => {
             //  alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)

               alert(err)
           }
       
       
           const handleViewInfoClick = (event: any): void => {
               event.preventDefault()    
              
             } 
    return (
        <form onKeyDown={handleHotkey}>
            <ClientPicker gsb={gsb} isOpen={isClPickerOpen} onClose={()=>setIsClPickerOpen(false)} onSelect={(ac)=>{setClCodeValue(ac.d_acCode); setIsClPickerOpen(false)}}/>
            {/*<IPOStockPicker gsb={gsb} isOpen={isIPOPickerOpen} onClose={()=>setIsIPOPickerOpen(false)} onSelect={(IPO)=>{setIPOSTKNoValue(IPO.d_StkNo);setIPOApplyDateValue(IPO.d_ApplyDate); setIsIPOPickerOpen(false)}}/>*/}
           {/*<IPOStockPicker gsb={gsb} isOpen={isIPOPickerOpen} onClose={()=>setIsIPOPickerOpen(false)} onSelect={(IPO)=>{setIPOSTKNoValue(IPO.d_StkNo);setIPOStockValue(IPO.d_StkCode) ;setIPOStkNameValue(IPO.d_StkName);
                setIPOApplyDateValue(IPO.d_ApplyDate);setIPOListingDateValue(IPO.d_ListingDate);setIPOApplyPriceValue(utils.numToString(IPO.d_ApplyPrice));setIPOComRateValue(utils.numToString(IPO.d_CommRate));setIPOLotSize(utils.numToString(IPO.d_LotSize));
                setIPOHandlingFee(utils.numToString(IPO.d_HandlingFee));setIPOIntRateValue(utils.numToString(IPO.d_IntRate));setIPOLoanDay(utils.numToString(IPO.d_LoanDay));setIPORebateRateValue(utils.numToString(IPO.d_RebateRate));setIsIPOPickerOpen(false)}}/>*/}
            <IPOStockPicker gsb={gsb} isOpen={isIPOPickerOpen} onClose={()=>setIsIPOPickerOpen(false)} onSelect={(IPO)=>{setIPOSTKNoValue(IPO.d_StkNo); setIsIPOPickerOpen(false)}}/>
                    
         
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>

            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Seq No." labelFor="inputSeqNo"  >
                    <InputGroup className="inputNumberNoSpin" disabled={isNew} id="inputSeqNo" name="d_Seq" autoFocus={isNew} defaultValue="0" type="number" inputRef={register} />
                    {errors.d_Seq && errors.d_Seq.type === "required" && (<span id="Err_msg">Seq No. cannot be Blank</span>)}
                    {errors.d_Seq && errors.d_Seq.types && <span id="Err_msg">{errors.d_Seq.types.message}</span>}
                </FormGroup>

                <FormGroup className="Col-2-1" label="Pre-Paid Amount" labelFor="inputPrePaidAmtoSB"  >
                    {/*<InputGroup className="inputPrePaidAmtoSB" disabled={false} id="inputPrePaidAmtoSB" name="d_OAPOST" autoFocus={isNew}  inputRef={register} /> */}
                    {Fini.d_OAPOST}                   
                </FormGroup> 
          
                <FormGroup className="Col-3-1" label="Qty posted" labelFor="inputQtyToSB" >
                    {/*<InputGroup className="inputQtyToSB" disabled={true} id="inputQtyToSB" name="d_OIPOST" autoFocus={isNew} inputRef={register} />*/}
                    {Fini.d_OIPOST}   
                </FormGroup>
              
         
                <FormGroup className="Col-4-1" label="Amount posted" labelFor="inputAmtPostedToSb">
                   {/*<InputGroup className="inputAmtPostedToSb" disabled={false} id="inputAmtPostedToSb" name="d_OIAMTPOST" autoFocus={isNew}  inputRef={register} /> */}
                   {Fini.d_OIAMTPOST }
                </FormGroup>    

                <FormGroup className="Col-5-1" label="Input User" labelFor="inputInputUser">
                    <InputGroup disabled={true} id="inputInputUser" name="d_Input_User" defaultValue="" placeholder="Input User ..." inputRef={register({ maxLength: 10}) } />
                    {errors.d_Input_User && errors.d_Input_User.type === "maxLength" && <span id="Err_msg">Max length is 10</span>}
                    {errors.d_Input_User && errors.d_Input_User.types && <span id="Err_msg">{errors.d_Input_User.types.message}</span>}
                </FormGroup>
               
            
                <FormGroup className="Col-1-1" label="cheque No." labelFor="inputChequeNo" labelInfo="*">
                    <InputGroup className="inputChequeNo" disabled={isNew} id="inputChequeNo" name="d_OCHQ" autoFocus={isNew}   defaultValue="" inputRef={register} />
                    {errors.d_OCHQ && errors.d_OCHQ.type === "required" && (<span id="Err_msg">Seq No. cannot be Blank</span>)}
                    {errors.d_OCHQ && errors.d_OCHQ.types && <span id="Err_msg">{errors.d_OCHQ.types.message}</span>}
                </FormGroup>

                <FormGroup className="Col-1-2" label="cheque No." labelFor="inputFiniStatus" labelInfo="*">
                    <InputGroup className="inputFiniStatus" disabled={isNew} id="inputFiniStatus" name="d_Status" autoFocus={isNew}   defaultValue="" inputRef={register} />
                    {errors.d_Status && errors.d_Status.type === "required" && (<span id="Err_msg">Seq No. cannot be Blank</span>)}
                    {errors.d_Status && errors.d_Status.types && <span id="Err_msg">{errors.d_Status.types.message}</span>}
                </FormGroup>

            </div>
            <div className="Row">

                <FormGroup className="Col-1-2" label="Stock No" labelFor="inputStkNo" labelInfo="">
                                                       
                    <InputGroup id="inputStkNo"  value={IPOStkNoValue} defaultValue="" placeholder="Stock No. ..." onChange={utils.handleStringChange(s => setIPOSTKNoValue(s)) } inputRef={register({ required: true }) } 
                        rightElement={<Button icon="double-chevron-down" minimal onClick={() => {setsetIPOSTKNoValue(()=>setIPOStkNoValue);setIsIPOPickerOpen(true)}}></Button>}
                    />
                    {errors.d_StkNo && errors.d_StkNo.type === "required" && <span id="Err_msg">stock No. cannot be Blank</span>}
                    {errors.d_StkNo && errors.d_StkNo.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                    {errors.d_StkNo && errors.d_StkNo.types && <span id="Err_msg">{errors.d_StkNo.types.message}</span>}
                         
                </FormGroup>
                <FormGroup className="Col-3-2" label="Stock Code" labelFor="inputStk">
                    {/*
                    <InputGroup readOnly value={Fini.d_StkCode} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_StkCode.toString() == "") && 
                    <div id="DispText2" > {Fini0.d_StkCode} </div> }*/}
                    <div id="DispText" > {(IPOStockValue)} </div>         
                </FormGroup>   

                <FormGroup className="Col-5-3" label="Stock Name" labelFor="inputStkName">
                {/*<InputGroup readOnly value={Fini.d_StkName} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (Fini0.d_StkName.toString() == "") && 
                    <div id="DispText2" > {Fini0.d_StkName} </div> }*/}

                    <div id="DispText" > {(IPOStkNameValue)} </div>
                </FormGroup>   
                {/* 
                <FormGroup className="Col-8-3" label="Stock Name(Big5)" labelFor="inputStkBi5Name">

                    <div id="DispText" > {(IPOStkBig5NameValue)} </div>
                </FormGroup>   
                */}
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Lot size" labelFor="inputLotSize" >
                    <div id="DispText" > 
                        { IPOLotSize}
                    </div>                              
                </FormGroup >           
            </div>

            <div className="Spacing-V-16" />
            <div className="Row">
                 <FormGroup className="Col-1-2" label="Apply date" labelFor="inputOADATE">

                     <InputGroup id="inputOADATE" name="d_ApplyDate" type="date" value={IPOApplyDateValue} placeholder="YYYY-MM-DD" leftIcon="calendar"  onChange={utils.handleStringChange(s => setIPOApplyDateValue(s)) } inputRef={register} /> 
                    {errors.d_ApplyDate && errors.d_ApplyDate.types && <span id="Err_msg">{errors.d_ApplyDate.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="List date." labelFor="inputOLDATE">
                    <InputGroup id="inputOLDATE" name="d_ListingDate" type="date"  value = {IPOListingDateValue} placeholder="YYYY-MM-DD" leftIcon="calendar"  onChange={utils.handleStringChange(s => setIPOListingDateValue(s)) } inputRef={register} />
                    {errors.d_ListingDate && errors.d_ListingDate.types && <span id="Err_msg">{errors.d_ListingDate.types.message}</span>}
                </FormGroup>     
                {/*             
                <FormGroup className="Col-5-1" label="EIPO">
                    <InputGroup readOnly value={(Fini.d_OGENEPIO)} />                
                </FormGroup>
                */}
                <FormGroup className="Col-1-2" label="Apply Price." labelFor="inputApplyPrice" >
                   
                    <div>
                        <div id="DispText"> {(utils.ParseFloat(IPOApplyPriceValue,4)).toString()}</div>
                    </div>

                </FormGroup >

                <FormGroup className="Col-3-2" label="Comm Rate." labelFor="inputCommRate" >
                    <div>
                        <div id="DispText">{(IPOCommRateValue)} </div>
                    </div>
                </FormGroup >
            </div>
            
            <div className="Row">
                <FormGroup className="Col-1-2" label="Transaction Levy (%)">
                    <div>
                        <div id="DispText"> {Levy_RateValue}</div>
                    </div>
                 </FormGroup >
                
                 <FormGroup className="Col-3-2" label="AFRC Levy Rate(%)" labelFor="inputAFRCLevyRate" >

                   <div>
                        <div id="DispText"> {FLevy_RateValue}</div>
                    </div>

                    {/*
                    <InputGroup id="inputFLevy" defaultValue={FLevy_RateValue} value={FLevy_RateValue} onChange={utils.handleStringChange(n => setFLevy_RateValue(n))} />
                    {errors.d_AFRCLevyRate && errors.d_AFRCLevyRate.type === "min" && <span id="Err_msg">AFRC Levy Rate sholud be greater than 0 </span>}
                    {errors.d_AFRCLevyRate && errors.d_AFRCLevyRate.types && <span id="Err_msg">{errors.d_AFRCLevyRate.types.message}</span>}                */}
                </FormGroup >
               

                 <FormGroup className="Col-5-2" label="Trading Fee" labelFor="inputTradeRate" >
                    <div>
                        <div id="DispText"> {SLevy_RateValue}</div>
                    </div>
                </FormGroup >


                <FormGroup className="Col-7-2" label="Nominee Handling Fee (%)" labelFor="inputTHandlingFeee" >              
                    <InputGroup id="inputHandlingFee" readOnly={isNew}     type="text"  value={IPOHandlingFee}  onChange={utils.handleStringChange(s => setIPOHandlingFee(s)) }   autoFocus={! isNew} inputRef={register({ required: false }) } /> 
                    {errors.d_HandlingFee && errors.d_HandlingFee.types && <span id="Err_msg">{errors.d_HandlingFee.types.message}</span>}
                </FormGroup >

 
            </div>
            <div className="Spacing-V-16"/>   
 

            <div className="Row">
                <FormGroup className="Col-1-2" label="Account No." labelFor="inputacCode" labelInfo="*">
                    <InputGroup id="inputacCode" value={AcCodeValue} defaultValue=""  placeholder="Account No. ..." onChange={utils.handleStringChange(s => setClCodeValue(s)) } inputRef={register({ required: true , maxLength: 8}) } 
                        rightElement={<Button icon="double-chevron-down" minimal onClick={() => {setSetClCodeValue(()=>setClCodeValue); setIsClPickerOpen(true)}}></Button>}
                    />
                    {errors.d_acCode && errors.d_acCode.type === "required" && <span id="Err_msg">Account No. cannot be Blank</span>}
                    {errors.d_acCode && errors.d_acCode.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                    {errors.d_acCode && errors.d_acCode.types && <span id="Err_msg">{errors.d_acCode.types.message}</span>}
                </FormGroup>
                <FormGroup className="Col-3-2" label="Client Name." labelFor="inputAcName1"> 
                    <div>
                    <div id="DispText">{AcName1Value}</div>
                    <div id="DispText">{AcName2Value}</div>
                    </div>
                </FormGroup>
                <FormGroup className="Col-5-2" label="Runner." labelFor="inputRunner"> 
                    <div>
                    <div id="DispText">{AeCodeValue}</div>                 
                    </div>
                </FormGroup>
                <FormGroup className="Col-7-2" label="Status." labelFor="inputStatus"> 
                    <div>
                    <div id="DispText">{AcStatusValue}</div>                 
                    </div>
                </FormGroup>
            </div> 
          

            <div className="Row">
               <FormGroup className="Col-1-2" label="Receive Pre-Pay Date" labelFor="inputRecPrePayDate" >
                    <InputGroup id="inputRecPrePayDate" name="d_OPPDATE" type="date" autoFocus={! isNew} placeholder="YYYY-MM-DD" leftIcon="calendar" inputRef={register({ required: false }) } />                  
                    {errors.d_OPPDATE && errors.d_OPPDATE.types && <span id="Err_msg">{errors.d_OPPDATE.types.message}</span>}
                </FormGroup >  
                <FormGroup className="Col-1-2" label="Apply Qty." labelFor="inputApplyQty" >
                 
                    <InputGroup id="inputTradingFee"  type="text"  defaultValue={IPOApplyQtyValue} onChange={utils.handleStringChange(s => setIPOApplyQtyValue(s)) } autoFocus={! isNew} inputRef={register({ required: false }) } />        
                    {errors.d_ApplyQty && errors.d_ApplyQty.types && <span id="Err_msg">{errors.d_ApplyQty.types.message}</span>}                    
                </FormGroup >



                {/*Total Amount*/}
                {/*
                <FormGroup className="Col-3-2" label="Total Amount">                  
                    <InputGroup id="inputTradingFee" readOnly={isNew}     type="text"  value={d_ApplyAmount}  onChange={utils.handleStringChange(s => setd_ApplyAmount(s)) }   autoFocus={! isNew} inputRef={register({ required: false }) } /> 
                    {errors.d_ApplyAmount && errors.d_ApplyAmount.types && <span id="Err_msg">{errors.d_ApplyAmount.types.message}</span>}
                </FormGroup >

              
                */}

                <FormGroup className="Col-3-2" label="Total Amount">                  
                    <InputGroup id="inputTradingFee" readOnly value={IPOApplyAmtValue}  onChange={utils.handleStringChange(s => setIPOApplyAmtValue(s)) } /> 
                    {errors.d_ApplyAmount && errors.d_ApplyAmount.types && <span id="Err_msg">{errors.d_ApplyAmount.types.message}</span>}
                </FormGroup >
                
                {/*
                <FormGroup className="Col-3-2" label="Total Amount">                  
              
                    <InputGroup readOnly value={utils.formatNumber2(Fini.d_ApplyAmount)} />
                </FormGroup >
                */}


                {(GsbFlag.MULTI_MKT) && ( ! GsbFlag.SING_CURR) &&
                    <FormGroup className="Col-5-2" label="Currency" labelFor="inputCurrency" labelInfo="*">
                          <Suggest
                             
                                inputProps={{ placeholder: "Currency ..."}}
                                defaultSelectedItem={CurrencyList.find((Ccy) => Ccy.d_Currency === Fini.d_Currency)}
                                items={CurrencyList}
                                itemRenderer={CurrencyRenderer}
                                itemPredicate={CurrencyPredicate}
                                inputValueRenderer={CurrencyValueRenderer}
                                onItemSelect={(CurrencyList) => { setCurrencyValue(CurrencyList.d_Currency) }}
                            />
                        {errors.d_Currency && errors.d_Currency.types && <span id="Err_msg">{errors.d_Currency.types.message}</span>}
                    </FormGroup>
                }
            </div>
 
            {/*
            <div className="Row">
                <FormGroup className="Col-1-2" label="List Price." labelFor="inputListPrice" >
                        <InputGroup id="inputListPrice" readOnly name="d_OIPRICE" type="text"  autoFocus={! isNew} inputRef={register({ required: false }) } />                  
                        {errors.d_OIPRICE && errors.d_OIPRICE.types && <span id="Err_msg">{errors.d_OIPRICE.types.message}</span>}
                </FormGroup >
                <FormGroup className="Col-3-2" label="List Qty." labelFor="inputListQty" >
                    <InputGroup id="inputListQty" readOnly name="d_OISQTY" type="text" autoFocus={! isNew} inputRef={register({ required: false }) } />        
                    {errors.d_OISQTY && errors.d_OISQTY.types && <span id="Err_msg">{errors.d_OISQTY.types.message}</span>}                    
                </FormGroup >
            </div>
            */}    
            <div className="Row">               
                <FormGroup className="Col-1-2" label="Consideration" labelFor="inputConsiderartion" >
                    <InputGroup readOnly value={(utils.numToString3(Fini.d_Turnover))} /> 
                </FormGroup>
                {  <FormGroup className="Col-3-2" label="Commission Amount." labelFor="inputCommissionAmount" >
                    <InputGroup id="inputCommissionAmount" readOnly={isNew} defaultValue={EstCommAmtValue} value={EstCommAmtValue} onChange={utils.handleStringChange(n => setEstCommAmtValue(n))} />                  
                    {errors.d_EstCommAmt && errors.d_EstCommAmt.types && <span id="Err_msg">{errors.d_EstCommAmt.types.message}</span>}
                </FormGroup >
                }
            </div>
 
         


            <div className="Row">
                <FormGroup className="Col-1-2" label="Transacation Levy Amount" labelFor="inputLevy" >
                    <InputGroup id="inputLstPrQtyLevy" readOnly={isNew} defaultValue={TranscationLevyAmt} value={TranscationLevyAmt} onChange={utils.handleStringChange(n => setTranscationLevyAmt(n))} />                  
                    {errors.d_EstTransLevy && errors.d_EstTransLevy.types && <span id="Err_msg">{errors.d_EstTransLevy.types.message}</span>}
                </FormGroup >            

                 <FormGroup className="Col-3-2" label="AFRC Levy Amount" labelFor="inputAFRC" >
                    <InputGroup id="inputAFRC" readOnly={isNew} defaultValue={AFrcLevtAmt} value={AFrcLevtAmt} onChange={utils.handleStringChange(n => setAFrcLevtAmt(n))} />                  
                    {errors.d_OFLEVY && errors.d_OFLEVY.types && <span id="Err_msg">{errors.d_OFLEVY.types.message}</span>}
                </FormGroup >  

                <FormGroup className="Col-5-2" label="Trading Fee Amount" labelFor="inputTradingFee" >
                    <InputGroup id="inputTradingFee" readOnly={isNew} defaultValue={TradingFeeAmt} value={TradingFeeAmt} onChange={utils.handleStringChange(n => setTradingFeeAmt(n))} />                  
                    {errors.d_EstTradingFee && errors.d_EstTradingFee.types && <span id="Err_msg">{errors.d_EstTradingFee.types.message}</span>}
                </FormGroup >
            </div>
 
            <div className="Row">
                <FormGroup className="Col-1-2" label="Pre-Paid Rate" labelFor="inputPrePaidRate" >
                    <InputGroup id="inputPrePaid" defaultValue={PrePaidRateValue} value={PrePaidRateValue} onChange={utils.handleStringChange(n => setPrePaidRateValue(n))}  />                  
                    {errors.d_PrePaidRate && errors.d_PrePaidRate.types && <span id="Err_msg">{errors.d_PrePaidRate.types.message}</span>}
                </FormGroup >

                <FormGroup className="Col-3-2" label="Pre-Paid Amount" labelFor="inputPrePaidAmount" >
                    <InputGroup id="inputPrePaidAmount"  defaultValue={PrePaidAmtValue} value={PrePaidAmtValue} onChange={utils.handleStringChange(n => setPrePaidAmtValue (n))} />                  
                    {errors.d_PrePaidAmt && errors.d_PrePaidAmt.types && <span id="Err_msg">{errors.d_PrePaidAmt.types.message}</span>}
                </FormGroup >
                <FormGroup className="Col-5-2" label="Loan Amount" labelFor="inputLoanAmount" >
                    <InputGroup id="inputLoanAmount" readOnly={true} value={d_LoanAmt}  />                  
                    {errors.d_LoanAmt && errors.d_LoanAmt.types && <span id="Err_msg">{errors.d_LoanAmt.types.message}</span>}
                </FormGroup >

                <FormGroup className="Col-1-2" label="Interest Rate(%)" labelFor="inputInterestRate" >
                    {/*<InputGroup id="inputInterestRate"   type="text"  value = {IPOIntRateVaue} autoFocus={! isNew}  onChange={utils.handleStringChange(n => setIPOIntRateValue(n))}  inputRef={register({ required: false }) } /> */}
                    <InputGroup id="inputInterestRate"  name="d_IntRate" type="text"  value={IPOIntRateVaue}  onChange={utils.handleStringChange(n => setIPOIntRateValue(n))}   autoFocus={! isNew} inputRef={register({ required: false }) } />                  
                                      
                    {errors.d_IntRate && errors.d_IntRate.types && <span id="Err_msg">{errors.d_IntRate.types.message}</span>}
                </FormGroup >

                <FormGroup className="Col-3-2" label="Loan Day" labelFor="inputLoanDay" >
                    <InputGroup id="inputLoanDay" name="d_LoanDay" type="text" value={IPOLoanDay}  onChange={utils.handleStringChange(n => setIPOLoanDay(n))}  autoFocus={! isNew} inputRef={register({ required: false }) } />                  
                    {errors.d_LoanDay && errors.d_LoanDay.types && <span id="Err_msg">{errors.d_LoanDay.types.message}</span>}
                </FormGroup >


                <FormGroup className="Col-1-2" label="Rebate Rate(%)" labelFor="inputRebateRate" >
                    {/*<InputGroup id="inputRebateRate"  name="d_RebateRate" type="text"   value={IPORebateRateVaue}    onChange={utils.handleStringChange(n => setIPORebateRateValue(n))}   autoFocus={! isNew} inputRef={register({ required: false }) } />*/}
                   
                    <InputGroup id="inputRebateRate"  name="d_RebateRate" type="text"   value={IPORebateRateVaue} onChange={utils.handleStringChange(n => setIPORebateRateValue(n))}   autoFocus={! isNew} inputRef={register({ required: false }) } />                  
                    {errors.d_RebateRate && errors.d_RebateRate.types && <span id="Err_msg">{errors.d_RebateRate.types.message}</span>}
                </FormGroup >
 
                <FormGroup className="Col-3-2" label="Rebate Amount" labelFor="inputRebateAmount" >
                    <InputGroup id="inputRebateAmount" name="d_EstRebateAmt" type="text" autoFocus={! isNew}  inputRef={register({ required: false }) } />                  
                    {errors.d_EstRebateAmt && errors.d_EstRebateAmt.types && <span id="Err_msg">{errors.d_EstRebateAmt.types.message}</span>}
                </FormGroup >
            </div>

 


            
        </form>
    )
}

interface IPOEntryMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function IPOEntryMain({ gsb }: IPOEntryMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { acCode: defaultSearchValue = "" }: { acCode: string } = useParams()

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 
 
    const [data, setData] = useState([] as FiniInfo[])
    const [InputDateValue,serInputDateValue] = useState(utils.formatNumber(new Date()))
    
    const [CurrencyList, setCurrencyList] = useState([] as CurrencyInfo[])
 
    const [currentSbConfig, setCurrentSbConfig] = useState({} as sbConfig)
    const [BlankSbConfig, setBlankSbConfig] = useState({} as sbConfig)  

    
    const [searchKey, setSearchKey] = useState("StkNo")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)
    const [searchStkName, setsearchStkName] = useState("")
    const [searchApplyDate, setsearchApplyDate] = useState("")

    const [searchStkNo, setsearchStkNo] = useState("")        
    const [searchStk, setsearchStk] = useState("")

    const [showFilters, setShowFilters] = useState(false)

    const [searchIdNo, setSearchIdNo] = useState("")
    const [searchSMPID,setSearchSMPID] = useState("")
    //const [searchEcpRdStatus,setsearchEcpRdStatus] = useState("")
    const [searchCrsStatus,setsearchCrsStatus] = useState("")
    const [searchHolderType,setsearchHolderType] = useState("")
   
    

    const [searchName, setSearchName] = useState("") 
    const [def_id_Type, setid_Type] = useState("")
    const [searchTel, setSearchTel] = useState("")
    const [s_AcStatus, sets_AcStatus] = useState("")

    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [aPageShowInfo, setaPageShowInfo] = useState([] as PageInfo2[])
    const [PageReachEnd, setPageReachEnd] = useState(false)
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(20)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentAc, setCurrentAc] = useState({} as FiniInfo)
    const [currentAc2, setCurrentAc2] = useState({} as FiniInfo)


    //FiniInfo
    const [BlankAc, setBlankAc] = useState({} as FiniInfo)
    const [CurrentLog1, setCurrentLog1] = useState({} as FiniInfo)
    const [CurrentLog0, setCurrentLog0] = useState({} as FiniInfo)
    const [ViewMode, setViewMode] = useState("V")



    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [SUSPEND_AC, setSUSPEND_AC] = useState(false)
    
    const { t, i18n } = useTranslation();

    BlankAc.d_InputDate = "    -  -  "
    BlankAc.d_acCode = ""
    BlankAc.d_aeCode = ""
    BlankAc.d_status = ""
    BlankAc.d_Currency="HKD"
   
    // BlankIPO.d_StkNo =""
    BlankAc.d_aeCode ="C01"
    BlankAc.d_CommRate = utils.StringToNum("0.0000")
    BlankAc.d_ApplyPrice =  utils.StringToNum("0.0000")
    BlankAc.d_RebateRate = utils.StringToNum("0.0000")
    BlankAc.d_HandlingFee =utils.StringToNum("100")
    // show last stk
    BlankAc.d_StkNo = currentAc2.d_StkNo
    
    BlankAc.d_ApplyType = "Y"
   // BlankAc.d_OPREPAID = utils.StringToNum("100.00")
    //Pre-Paid Ratio (%)
    BlankAc.d_PrePaidRate = utils.StringToNum("100.00")
  //  BlankAc.d_OPAYPERC ="100.00"
   // BlankAc.d_AFRCLevyRate =  currentSbConfig.x_FLEVY_RATE   //"0.00015"   //AFRC rate
   // BlankAc.d_LevyRate =  currentSbConfig.x_FLEVY_RATE   //load from gsbconfig Transaction Levy 
   // BlankAc.d_TradingFeeRate =  currentSbConfig .x_SLEVY_RATE // "0.00565"    //Tradeing rate   A Trading Fee of 0.00565%
    BlankAc.d_OGENEPIO = "N"
    //BlankAc.d_OIAMTPOST =""
   // BlankAc.d_OIPOST =""
   // BlankAc.d_OAPOST = ""
 
    BlankAc.d_OSKIPCHQ ="Y"  // for EIPO

    BlankAc.d_ApplyAmount = 0
    BlankAc.d_PrePaidAmt = 0
    BlankAc.d_Skip_Recal = "N"  // skip re-calc
  /*
    useEffect(() => {
        setnPage(1)
        if ( nPage > 0 ) {
            //setcPrintMode("PS")
        } 

        (async () => {
            try {
                const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                            filters: {
                                Stk: searchStk,
                                StkName: searchStkName,
                                AppyDate:searchApplyDate,
                            }
                        },
                        cPgmId: "GsbConfig",
                        cAction: "ListRec",
                    });
                 //setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentSbConfig(res.data.data[0])
                }

                console.log("main res.data", res.data.data)
                console.log("main currentAc", currentSbConfig)
                //setCurrentMode("show")

             
                

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
 */

    useEffect(() => {
        (async () => {
            try {
                // get Market List
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "ExchangeRate", cAction: "GetCCYList"})

                //console.log("MarketList: ", res.data.data) 
                CurrencyList.push({d_Currency: "", d_CcyDesc: "HKD"})
                for (let j = 0; j < res.data.data.length; j++) {
                    CurrencyList.push({d_Currency: res.data.data[j][0], d_CcyDesc: res.data.data[j][1]})
                }
                setCurrencyList(CurrencyList)
                console.log("set CurrencyList: ", CurrencyList) 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                          
                        },
                        cPgmId: "GsbConfig",
                        cAction: "ListRec",
                    });
                 //setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentSbConfig(res.data.data[0])
                }
 

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');        
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
             
                UserID = res.data.Flag.UserID  
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setSUSPEND_AC(GsbFlag.SUSPEND_AC);

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("IPOEntryMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            //setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])


    useEffect(() => {
        if (logviewonly === "Y") {
            setViewMode("L")
        }
        
        ;
        (async () => {
            try {
                if ( logKey.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_logKey: logKey,
                        }, 
                        cPgmId: "IPOEntry", 
                        cAction: "ViewLogRec"
                    })
                    //console.log("IPOEntryMain ViewLogRec res.data.data", res.data.data)

                    if (res.data.ok) {
                        setCurrentLog0(res.data.data[0])
                        setCurrentLog1(res.data.data[1])
                    } else {
                        utils.showWarn(res.data.data)
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, logKey])
 
 

    const PrevRecProcess = async (Fini: FiniInfo) => {
        try {
            //console.log("call PrevRecProcess", ac)
            const res = await gsb.post('/Master', {sb_data: Fini, cPgmId: "IPOEntry", cAction: "PrevRec"})
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Seq === res.data.data.d_Seq  && data[i].d_InputDate === res.data.data.d_InputDate ) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")

        } catch (error) {
            utils.showError(error)
        }
    }
 
    const ReplicateProcess = async (Fini: FiniInfo) => {
        try {
            //console.log("call ReplicateProcess", Crs)
            const res = await gsb.post('/Master', {sb_data: Fini, cPgmId: "IPOEntry", cAction: "ReplicateRec"})
            showSuccess("Account No. " + Fini.d_acCode + " record Holder No. Replicated")
            setisShowAlert1(true)
            setShowAlert1Msg("Account No. " + Fini.d_acCode + " record Holder No. Replicated")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode  && data[i].d_InputDate === res.data.data.d_InputDate ) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    } 
  
    const DeleteProcess = async (Fini: FiniInfo) => {
        try {
            Fini.d_AuthTran = ""
            if (isReqAuth2) {
                Fini.d_AuthTran = "Y"
            }
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/Master', {sb_data: Fini, cPgmId: "IPOEntry", cAction: "DelRec"})
            if (res.data.ok) {
                if (isReqAuth2) {
                    showSuccess("Seq No."+ Fini.d_Seq  + " (Input Date"+ Fini.d_InputDate+"), record deleting, waiting for authorization")
                } else {
                    showSuccess("Seq No."+ Fini.d_Seq  + " (Input Date"+ Fini.d_InputDate+"), record deleted")
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].d_Seq === res.data.data.d_Seq && data[i].d_InputDate === res.data.data.d_InputDate ) {
                            data[i] = { ...data[i], ...res.data.data }
                            setData(data)
                            break
                        }
                    }
                }
                setCurrentAc(res.data.data)               
                setCurrentMode("show")
                if (isReqAuth2) {
                    alert("Seq No."+ Fini.d_Seq + " (Input Date"+ Fini.d_InputDate+"), record deleting, waiting for authorization")
                }
            } else {
                setisShowAlert2(true)
                setShowAlert2Msg(res.data.err_Msg)
            }
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (Fini: FiniInfo) => {
        try {
            console.log("call NextRecProcess", Fini)
            const res = await gsb.post('/Master', {sb_data: Fini, cPgmId: "IPOEntry", cAction: "NextRec"})
            //console.log("NextRecProcess show 1: ", stk.d_StkNo)
            console.log("NextRecProcess data : ", data)
            console.log("NextRecProcess res.data : ", res.data.data)
                //console.log("PrevRecProcess res.data.data : ", res.data.data)
            setCurrentAc(res.data.data)
            //console.log("PrevRecProcess show 2: ", stk.d_StkNo)
            setCurrentMode("show")
            //console.log("PrevRecProcess show 3: ", stk.d_StkNo)
        } catch (error) {
            utils.showError(error)
        }
    }
/*
        const res = await gsb.post('/Transaction', {sb_data: Fini, cPgmId: "IPOEntry", cAction: "AddRec"})
        showSuccess("Seq No. " + res.data.data.d_Seq + " record added")
        for (let i = 0; i < data.length; i++) {
            if (data[i].d_Seq === res.data.data.d_Seq) {
                data[i] = { ...data[i], ...res.data.data }
                setData(data)
                break
            }
        }
        setCurrentAc(res.data.data)
        setCurrentMode("show")
*/
    const newOnSave = async (Fini: FiniInfo) => {
        try {
            //console.log("call newOnSave", Fini)
            const res1 = await gsb.post('/GsbFlag');
            //console.log("MenuBar disp user_key: ", res.data.Flag.user_key)
            GsbFlag = res1.data.Flag;

            const res = await gsb.post('/Master', {sb_data: Fini, cPgmId: "IPOEntry", cAction: "AddRec"})
            showSuccess ("Seq No. " + res.data.data.d_Seq + " (Input Date:" + res.data.data.d_InputDate + ") record added")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_Seq === res.data.data.d_Seq && data[i].d_InputDate === res.data.data.d_InputDate ) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")

        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }


    const editOnSave = async (Fini: FiniInfo) => {
        try {
            console.log("call editOnSave", Fini)
             //console.log("call newOnSave", Fini)
            const res1 = await gsb.post('/GsbFlag');
             //console.log("MenuBar disp user_key: ", res.data.Flag.user_key)
            GsbFlag = res1.data.Flag;
             
            const res = await gsb.post('/Master', {sb_data: Fini, cPgmId: "IPOEntry", cAction: "UpdateRec"})
            if (isReqAuth2) {
                console.log("Seq No."+ Fini.d_Seq + " (Input Date:" + res.data.data.d_InputDate + ") record saving, waiting for authorization")
                showSuccess("Seq No."+ Fini.d_Seq + " (Input Date:" + res.data.data.d_InputDate + ") record saving, waiting for authorization")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_Seq  === res.data.data.d_Seq && data[i].d_InputDate === res.data.data.d_InputDate  ) {
                        setCurrentAc(data[i])
                        break
                    }
                }
                setCurrentMode("show")
                //alert("Account No. " + Bcan.d_acCode + " record saving, waiting for authorization")
                setisShowAlert1(true)
                setShowAlert1Msg("Seq No."+ Fini.d_Seq + " (Input Date:" + res.data.data.d_InputDate + ") record saving, waiting for authorization")
                console.log("Seq No."+ Fini.d_Seq + " (Input Date:" + res.data.data.d_InputDate + "), record saving, waiting for authorization")
            } else {
               
                showSuccess("Seq No."+ Fini.d_Seq + " (Input Date:" + res.data.data.d_InputDate + ") record saved")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_Seq === res.data.data.d_Seq  && data[i].d_InputDate === res.data.data.d_InputDate ) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
                setCurrentAc(res.data.data)
                setCurrentMode("show")
                console.log("call editOnSaved", Fini)
                
            }
        } 
        catch (error) {
            utils.showError(error)
        }
        
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(0)
        setnTotalPage(0)
        setPageReachEnd(false)

        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }

        try {
            if ( m_limit > 1 ) {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        PageShowInfo: aPageShowInfo,
                        refreshPageShow: true,
                        backward: searchBackward,
                        SortByName: false,
                        filters: {
                            AcStatus:s_AcStatus,                          
                            Holdertype: searchHolderType, 
                            CrsStatus:searchCrsStatus,
                        },
                    },
                    cPgmId: "IPOEntry",
                    cAction: "ListRec",
                });

                console.log("ListRec res.data.data", res.data.data)
                console.log("ListRec res.data.count", res.data.count)
                 setData(res.data.data)
                setaPageShowInfo(res.data.PageShowInfo)

                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }

                if ( res.data.count > 0 ) {
                    {/*
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                    */}
                  
                    const aPageNumber1 = []
                    let k = 0
                    for ( let j = 1; j <= res.data.PageShowInfo.length; j++ ) {
                        if ( res.data.PageShowInfo[j-1].pageShow ) {
                            k++
                            aPageNumber1.push({n: res.data.PageShowInfo[j-1].pageno});
                            if ( res.data.PageShowInfo[j-1].pageLast ) { 
                                setnTotalPage(res.data.PageShowInfo[j-1].pageno)
                                setPageReachEnd(true)
                            }
                        }
                    }
                    setaPageNumber(aPageNumber1)
                    setnPage(1)
                    console.log("ListRec k", k, aPageNumber1)
                } else {
                    setnPage(0)
                    setnTotalPage(0)
                   
                }
            } else {
                const res = await gsb.post('/Master',
                {   sb_data: {
                        d_acCode: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "IPOEntry",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setCurrentAc(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }
            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && selectedTabId == "list" ) {
    
            setShowWait(true)
            setPageReachEnd(false)

            ;
    
            (async () => {
                try {
                    //console.log("IntRMastMain useEffect nPage > 0  ", nPage)

                    /*
       <option value="acCode">Account</option>
                                    <option value="acName">Account Name</option>
                    */
                    const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            PageShowInfo: aPageShowInfo,
                            refreshPageShow: false,
                            backward: searchBackward,
                            SortByName: false,
                            filters: {
                                Stk: searchStk,
                                StkName: searchStkName,
                                AppyDate:searchApplyDate,                               
                            },
                            },
                        cPgmId: "IPOEntry",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    setaPageShowInfo(res.data.PageShowInfo)

                    if (res.data.data.length > 0) {
                        setCurrentAc(res.data.data[0])
                    }
 
                    if ( res.data.count > 0 ) {
                        const aPageNumber1 = []
                        let k = 0
                        for ( let j = 1; j <= res.data.PageShowInfo.length; j++ ) {
                            if ( res.data.PageShowInfo[j-1].pageShow ) {
                                k++
                                aPageNumber1.push({n: res.data.PageShowInfo[j-1].pageno});
                                if ( res.data.PageShowInfo[j-1].pageLast ) { 
                                    setnTotalPage(res.data.PageShowInfo[j-1].pageno)
                                    setPageReachEnd(true)
                                }
                            }
                        }
                        setaPageNumber(aPageNumber1)
                        //console.log("ListRec Press k", k, aPageNumber1)
                    }
                   
 
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    // currentMode = show
    let detail = <IPOEntryView gsb={gsb} Fini={currentAc} Fini0={currentAc}  CurrencyList={CurrencyList} GsbConfig={currentSbConfig}  baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")}  onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ViewMode={ViewMode} logKey2={logKey2.trim()} PgmMode="IPOENTRY" ></IPOEntryView>
    switch (currentMode) {
        case "edit":
          
            detail = <IPOEntryEdit gsb={gsb} Fini={currentAc} CurrencyList={CurrencyList}  GsbConfig={currentSbConfig}  onSave={editOnSave} onCancel={() => setCurrentMode("show")} PgmMode="IPOEntry" ></IPOEntryEdit>
            break
        case "new":
            //detail = <BrokerTranEntryEdit gsb={gsb} BrokerTran={BlankBrokerTran} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } } ></BrokerTranEntryEdit>

            console.error("new" )
            detail = <IPOEntryEdit gsb={gsb} Fini={BlankAc} CurrencyList={CurrencyList} GsbConfig={currentSbConfig}  isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } } PgmMode="IPOEntry" ></IPOEntryEdit>
            break
    }

    //let logKeyViewRec = <IPOEntryView gsb={gsb} Fini={CurrentLog1} Fini0={CurrentLog0}  baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")}  onReplicate={() => ReplicateProcess(currentAc)} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ViewMode={ViewMode} logKey2={logKey2.trim()} PgmMode="HKCRS"  ></IPOEntryView>

    let logKeyViewRec = <IPOEntryView gsb={gsb} Fini={CurrentLog1} Fini0={CurrentLog0}  GsbConfig={currentSbConfig} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")}  onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ViewMode={ViewMode} logKey2={logKey2.trim()} PgmMode="IPOENTRY"  ></IPOEntryView>
    function PageNo(n: number) {
        if (n > 0 ) {
            if (  nPage+n <= nTotalPage || nTotalPage == 0 ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }


 
 
    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nPage > 0) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                 {aPageNumber.map((no, j) => 
                    (no.n < nPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (no.n > nPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nPage > 0) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
                { (nPage > 0) && ! ( PageReachEnd ) &&
                    <Button minimal >...</Button>
                }
            </FormGroup>
        </div>
    </>
 

    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-100" >Seq No.</th> 
                <th className="TCol-100" >Input Date</th>
                <th className="TCol-StkNo">Account No.</th>   
                <th className="TCol-StkCode">Name</th>            
                <th className="TCol-StkCode">Stock No.</th>
                <th className="TCol-StkNo">Stock Code</th>
                <th className="TCol-StkCode">Stock Name</th>
                <th className="TCol-IPO">Apply Price</th>
                <th className="TCol-Ex_date">Qty</th>                
                <th className="TCol-BC_date">Skip Print cheque</th>
                <th className="TCol-BC_date">Comm Rate</th>
                <th className="TCol-BC_date">Loan Day</th>
                <th className="TCol-BC_date">Total Amount</th>
                <th className="TCol-PY_date">Exported IPO</th> 
                <th className="TCol-PY_date">Apply Date</th>  
                <th className="TCol-PY_date">Pre-Paid Amt posted</th>  
                <th className="TCol-PY_date"> Qty posted</th>   
                <th className="TCol-PY_date"> Amount posted</th>  
          
                {/*<th className="TCol-100" >Last Update Date</th>*/}
            </thead>
            <tbody id="ma_tr">
                {data.map((FINI, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_Seq}</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_InputDate}</td>       
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_acCode}</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_acName1}</td>                   
                        <td className="TCol-StkCode" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_StkNo}</td>                        
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_StkCode}</td>
                        <td className="TCol-StkCode" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_StkName}</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_ApplyPrice}</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_ApplyQty}</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_OSKIPCHQ}</td>     
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_CommRate}</td>    
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_LoanDay}</td>    
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{utils.formatNumber2(FINI.d_ApplyAmount)}</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_OGENEPIO==='G' ? <Icon  icon="tick"/> : ''}</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_ApplyDate}</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_OAPOST}</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_OIPOST}</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_OIAMTPOST}</td>
                         {/*<td className="TCol-StkNo" onClick={() => { setCurrentAc(FINI) ; MoblieDev && setSelectedTabId("detail") }}>{FINI.d_LastUpdateDate}</td>*/}
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>
            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                { ! ( logviewonly === "Y" ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H4><div style={{justifyContent: 'flex-end'}}>IPO Entry</div></H4>
                    <div className="Row No-Print">
                        <FormGroup className="Col-1-5" label="Search for" labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="acCode">Account</option>
                                    <option value="acName">Name</option>
                                    <option value="StkNo">StockNo</option>
                                    <option value="StkName">StockName</option>                                   
                                    {/* <option value="_recordNo">Record No.</option> */}
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "acCode"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "acCode"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        {/* <Checkbox className="Col-6-1 Checkbox-LabeledFormGroup" label="Backward" onChange={utils.handleBooleanChange(v => setSearchBackward(v))} /> */}
                        <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>
                    </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                            {/* define search filter */}
                            <FormGroup className="Col-1-2" label="Appy Date" labelFor="searchApplyDate">
                               <InputGroup id="searchApplyDate"   value={searchApplyDate} type ="date"  placeholder="YYYY-MM-DD" onChange={utils.handleStringChange(s => setsearchApplyDate(s))} />
                            </FormGroup>
                            <FormGroup className="Col-1-2" label="Stock Code" labelFor="searchStk">
                                <InputGroup id="searchStk" value={searchStk} onChange={utils.handleStringChange(s => setsearchStk(s))} />
                            </FormGroup>
                            <FormGroup className="Col-3-1" label="Stock Name." labelFor="searchStkName">
                                <InputGroup id="searchStkNo" value={searchStkName} onChange={utils.handleStringChange(s => setsearchStkName(s))} />
                            </FormGroup>
                            
                            {/* <FormGroup className="Col-6-2" label="No. of record(s) to List" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup> */}
                        </div>
                    </Collapse>
                  
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card> }
                {ViewMode === "L" && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>IPO Entry Audit Log View</H3> 
                    <div className="Spacing-V-16" />
                    {logKeyViewRec}
                </Card> }

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default IPOEntryMain



